import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import { ToastContainer } from 'react-toastify';
import StatementsList from './StatementsList';

const Statements = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'Declaración', icon: 'icon-bookmark' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Ver Declaraciones' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<StatementsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Statements;
